import { SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE } from "../languages";

const localizedPaths = (paths: string[]) => {
  const nonDefaultLanguages = SUPPORTED_LANGUAGES.filter(
    (language) => language !== DEFAULT_LANGUAGE
  );

  return [
    ...paths,
    ...nonDefaultLanguages.flatMap((language) =>
      paths.map((path) => {
        if (path === "/") {
          return `/${language}`;
        }

        return `/${language}${path}`;
      })
    ),
  ];
};

const routes = [
  {
    path: localizedPaths(["/", "/home"]),
    exact: true,
    component: "Home",
  },
  {
    path: localizedPaths(["/courses"]),
    exact: true,
    component: "Courses",
  },
  {
    path: localizedPaths(["/courses/:courseSlug"]),
    exact: true,
    component: "Course",
  },
  {
    path: localizedPaths(["/practice/personalgoals"]),
    exact: true,
    component: "PersonalGoals",
  },
  {
    path: localizedPaths(["/practice/:practiceSlug"]),
    exact: true,
    component: "Practice",
  },
  {
    path: localizedPaths(["/organizations"]),
    exact: true,
    component: "ForTeams",
  },
  {
    path: localizedPaths(["/podcast"]),
    exact: true,
    component: "Podcast",
  },
];

export default routes;
